<script>
	// Stores 
	import { alt } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Garantias Locatícias';    
</script>

<PageHeader title={titlePage}></PageHeader> 
   
<div class="container">
	<p>Confira os tipos de garantias locatícias disponíveis e a o que é necessário em cada uma delas.</p>
	<hr>
	<div class="box-itens-icon">
		<div class="item">
			<div class="icone">
				<i class="fas fa-user-shield fa-5x fa-fw color-accent"></i>
			</div>
			<div class="info">
				<h3>Fiador(es)</h3>
				<p>Solicitamos um fiador com dois bens imóvel ou dois fiadores com um bem imóvel (Livres de ônus).</p>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-hands-usd fa-5x fa-fw color-accent"></i>
			</div>
			<div class="info">
				<h3>Seguro Fiança</h3>
				<p>É o seguro de fiança locatícia que facilita a locação e tem a vantagem de evitar a procura de um fiador. O cliente efetuará o pagamento de 2 aluguéis mais encargos para a seguradora fazer a fiança da locação, este valor não tem restituição no final da locação e se renova anualmente.</p>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-money-check-alt fa-5x fa-fw color-accent"></i>
			</div>
			<div class="info">
				<h3>Titulo de capitalização</h3>
				<p>O cliente adquire um titulo de capitalização equivalente 12 vezes o valor do aluguel, no momento que encerrar a locação e estando tudo certo com o imóvel, e todas as taxas em dia tem o retorno do valor corrigido pela TR (O resgate do valor total somente poderá ser efetuado após 12 meses de locação).</p>
			</div>
		</div>
	</div>
	<br />
	<p>Em caso de dúvidas, entre em <a href="/contato">contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>
	<div class="button text-center mt-40">
		<a href="/documentacao-necessaria" class="btn btn-primary">Confira a Documentação para Locação <i class="far fa-arrow-right"></i></a>
	</div>
	<br />
</div>